import {
  css,
  html,
  LitElement,
  PropertyValues,
} from 'lit';
import {customElement, property, state} from 'lit/decorators';
import { classMap } from 'lit/directives/class-map';




@customElement('silver-tools')
export class SilverTools extends LitElement {

  static styles = [
  css`
    :host {
      display:inline-block;
      --tools-height:56px;
    }

    .container {
      margin-top: 8px;
    }

    .title {
      display: flex;
      height: var(--tools-height);
      align-items: center;
    }

    .title .background {
      position: absolute;
      inset: 8px 0 0 0;
      background: darkgray;
      border: solid #606060;
      border-width: 4px 0px 4px 0px;
      opacity:0.8;
    }

    .title .logo {
      position: relative;
      top:0px;
      padding-right: 10px;
    }

    .title .logo img {
      height:calc(var(--tools-height) + 8px);
      filter: drop-shadow(5px 5px 2px rgba(0,0,0,0.5));
    }

    .title .caption {
      flex: 1;
      color:white;
      font-family: Arial;
      font-weight: bold;
      font-size: 20px;
      z-index:1;
    }

    .tools {
      position:absolute;
      left: 64px;
      right:0px;
      top:calc(var(--tools-height) - 12px);
      display:flex;
      align-items: center;
    }

    .tools .tool {
      position:relative;
      padding-right:12px;
      cursor:pointer;
    }

    .tools .filler {
      flex: 1;
    }

    .tools .tool img {
      filter: drop-shadow(5px 5px 2px rgba(0,0,0,0.5));
    }



    .tools .tool.selected img {
      filter:grayscale(100%) brightness(120%) sepia(90%) hue-rotate(20deg) saturate(500%) contrast(0.7);
    }

  `
  ];

  @property()
  caption:string;

  @state()
  toolSelected:string;

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
  }

  public doSelectTool(name:string) {
    if (name == "identify" || name == "measure") {
      this.toolSelected = name;
    } 
    let toolEvent = new CustomEvent<IToolEvent>('tool',{
      detail:{
        tool: name
      }});
    this.dispatchEvent(toolEvent);
  }



  render() {
    return html`
    <div class="container">
      <div class="title">
        <div class="background"></div>
        <div class="logo"><img src="../../../SilverBrowser/ui/resources/logo256.png"></div>
        <div class="caption">${this.caption}</div>
        <div class="tools">
          <div id="tool-identify" class="tool ${classMap({selected:(this.toolSelected == 'identify')})}" title="identifica" @click=${()=> this.doSelectTool('identify')} >
            <img src="resources/image/identify.png">
            <div class="selection"></div>
          </div>
          <div id="tool-search" class="tool" title="cerca" @click=${()=> this.doSelectTool('search')} >
            <img src="resources/image/search.png">
          </div>
          <div id="tool-measure" class="tool ${classMap({selected:(this.toolSelected == 'measure')})}" title="misura" @click=${()=> this.doSelectTool('measure')} >
            <img src="resources/image/measure.png">
          </div>
          <div id="tool-legend" class="tool" title="legenda" @click=${()=> this.doSelectTool('legend')} >
            <img src="resources/image/legend.png">
          </div>
          <div id="tool-documents" class="tool" title="documenti" @click=${()=> this.doSelectTool('documents')} >
            <img src="resources/image/docs.png">
          </div>
          <div id="tool-print" class="tool" title="stampa" @click=${()=> this.doSelectTool('print')} >
            <img src="resources/image/print.png">
          </div>
          <div class="filler"></div>
          <div id="tool-help" class="tool" title="aiuto" @click=${()=> this.doSelectTool('help')} >
            <img src="resources/image/help.png">
          </div>
        </div>
      </div>
    </div>
    `
  }


}

export interface IToolEvent {
  tool:string;
}